module.exports = __webpack_public_path__ + "images/emoji/arrow_lower_right.d14d2a282be1a4e04691.png";